// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2B3Sc","footer":"ModalCreateQualiphyProcedure_footer__247p6","additionData":"ModalCreateQualiphyProcedure_additionData__1OlRb"};